import useElement from "backend/hooks/elements/useElement";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import ToolbarWithHeading from "./ToolbarWithHeading";

function parseElementJsAttr(raw: string | undefined): Record<string, unknown> | null {
  if (raw == null || raw === "") return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (parsed !== null && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    /* invalid JSON in JS_ATTR — fall back to element name */
  }
  return null;
}

const ToolbarWithMeasureName = () => {
  const ctx = useAppContext();
  const { data } = useElement(ctx.elementId);
  const metadata = parseElementJsAttr(data?.JS_ATTR);
  const localized = metadata?.["Localized-Text-Attributes"] as
    | Record<string, { Name?: string }>
    | undefined;
  const measureName = metadata
    ? localized?.[ctx.language]?.Name
    : data?.name;
  return <ToolbarWithHeading>{measureName ?? data?.name ?? ""}</ToolbarWithHeading>;
};

export default ToolbarWithMeasureName;
